import { AppState } from '../index';
import { IToastOptions } from '../../core/models';

export const isToastOpenSelector = ({ toastState }: AppState): boolean => toastState?.toastOpen;
export const toastOptionsSelector = ({ toastState }: AppState): IToastOptions => toastState?.toastOptions;
